/** ref_accounts.live_url에 저장된 유튜브 URL(watch/live/embed/short 링크 등)에서 영상 ID를 추출한다. */
export function extractYoutubeId(url: string): string | null {
  const trimmed = url.trim();
  if (!trimmed) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=)([\w-]{11})/,
    /(?:youtube\.com\/live\/)([\w-]{11})/,
    /(?:youtube\.com\/embed\/)([\w-]{11})/,
    /(?:youtube\.com\/shorts\/)([\w-]{11})/,
    /(?:youtu\.be\/)([\w-]{11})/,
  ];
  for (const re of patterns) {
    const m = trimmed.match(re);
    if (m) return m[1];
  }
  // 순수 11자리 영상 ID를 직접 저장해둔 경우
  if (/^[\w-]{11}$/.test(trimmed)) return trimmed;
  return null;
}

// hqdefault(480x360)/sddefault는 옛 4:3 규격이라 16:9 영상이면 상하 레터박스가 이미지에 박혀서 온다.
// mqdefault(320x180)는 순수 16:9라 레터박스는 없지만 해상도가 낮아 카드 크기로 확대하면 흐리다.
// maxresdefault(1280x720)는 레터박스 없는 고해상도지만 일부 영상엔 없을 수 있어(404), 실패 시
// mqdefault로 폴백한다 (buildYoutubeThumbnailFallback, 프론트에서 img onError로 연결).
/** 채널 목록 카드용 정지화면(썸네일) URL — 고해상도 우선. */
export function buildYoutubeThumbnail(liveUrl: string): string | null {
  const id = extractYoutubeId(liveUrl);
  if (!id) return null;
  return `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
}

/** maxresdefault가 없는(404) 영상을 위한 저해상도 폴백 썸네일. */
export function buildYoutubeThumbnailFallback(liveUrl: string): string | null {
  const id = extractYoutubeId(liveUrl);
  if (!id) return null;
  return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
}

/** 배경 자동재생용 embed URL 생성 (무음 자동재생 + 컨트롤 숨김 + 동적 origin). */
export function buildLiveEmbedSrc(liveUrl: string, origin: string): string | null {
  const id = extractYoutubeId(liveUrl);
  if (!id) return null;
  return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&iv_load_policy=3&playsinline=1&enablejsapi=1&origin=${encodeURIComponent(origin)}`;
}
